import React from "react";
import { Outlet } from "react-router-dom";
import { NavItemType, SideBarNavMenu } from "@whatslly/ui-components/SideBarNavMenu";
import styles from "./crm-settings-layout.module.scss";
import { ModalProviderInline } from "@whatslly/ui-components/modals";
import { useDeprecatedGlobalStyles } from "@whatslly/ui-components/styles/useTheme";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { mergeRefs } from "react-merge-refs";
import { useDependencyInjector } from "@whatslly/commons/di";
import { TuvisSettingsStore } from "../../stores/TuvisSettingsStore";
import { LOADER_IMG } from "@whatslly/commons/constants";
import { CrmComponentsErrorBox } from "@whatslly/ui-components/v2/CrmComponentsErrorBox";
export const TuvisSettingsLayout: React.FC<{ ignoreDarkMode?: boolean; useButtonNav?: boolean }> = observer<{
  ignoreDarkMode?: boolean;
  useButtonNav?: boolean;
}>(
  React.forwardRef((props, ref) => {
    const tuvisSettingsStore = useDependencyInjector(TuvisSettingsStore);
    const { t } = useTranslation();
    const localRef = React.useRef<HTMLDivElement>(null);
    if (!props.ignoreDarkMode) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useDeprecatedGlobalStyles({ element: localRef.current ?? undefined });
    }

    return (
      <div ref={mergeRefs([localRef, ref])} className={styles.layout}>
        <ModalProviderInline />
        {tuvisSettingsStore.init.case({
          pending: () => {
            return (
              <div className={styles.page}>
                <div className={styles.loaderWrapper}>
                  <img src={LOADER_IMG} alt="loader" />
                  <div>{t("autoSyncPage.loading")}</div>
                </div>
              </div>
            );
          },
          fulfilled: ({ showAutoSyncActivities, showNotificationSettings, showGlobalLayout, showAutoSyncCases }) => {
            return (
              <>
                <SideBarNavMenu
                  userNavButton={props.useButtonNav}
                  menuItems={
                    [
                      {
                        title: t("crm_settings.country_code"),
                        to: "/settings/country-codes",
                        iconName: "globe",
                      },
                      {
                        title: t("crm_settings.users_deactivation"),
                        to: "/settings/users-deactivation",
                        iconName: "users-deactivation",
                      },
                      {
                        title: t("crm_settings.auto_sync"),
                        to: "/settings/auto-sync",
                        iconName: "synchronize",
                      },
                      showNotificationSettings
                        ? {
                            title: t("crm_settings.notifications"),
                            to: "/settings/notifications",
                            iconName: "notifications-bell",
                          }
                        : (undefined as unknown as NavItemType),
                      showAutoSyncActivities
                        ? {
                            title: "Auto sync activities",
                            to: "/settings/auto-sync-activities",
                            iconName: "phone-contact",
                          }
                        : (undefined as unknown as NavItemType),
                      showAutoSyncCases
                        ? {
                            title: "Auto sync cases",
                            to: "/settings/auto-sync-cases",
                            iconName: "phone-contact",
                          }
                        : (undefined as unknown as NavItemType),
                      showGlobalLayout
                        ? {
                            title: t("globalLayout.title"),
                            to: "/settings/global-layout",
                            iconName: "star",
                          }
                        : (undefined as unknown as NavItemType),
                    ].filter(Boolean) as NavItemType[]
                  }
                />
                <div className={styles.pageContainer}>
                  <Outlet />
                </div>
              </>
            );
          },
          rejected: (error) => {
            return (
              <div className={styles.page}>
                <CrmComponentsErrorBox error={error.message} />
              </div>
            );
          },
        })}
      </div>
    );
  })
);
